<template>
    <div class="background">
        <div class="login-background">
            <div class="login-form-wrapper">
                <form class="default-form" @submit="loginSubmit" novalidate>
                    <div class="form-row">
                        <input name="email" type="email" placeholder="Email" autocomplete="off" autocapitalize="off" class="form-control" v-model="email">
                    </div>

                    <div class="form-row">
                        <input name="password" type="password" placeholder="Password" class="form-control" v-model="password">
                    </div>

                    <button class='btn btn-outline-secondary' type='submit'>Uloguj se</button>
                    <!-- loading gif -->
                    <img v-if="isLoggingIn" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="  alt=""/>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapMutations, mapGetters} from 'vuex'

    export default {
        name: 'AdminLogin',
        data() {
            return {
                email: '',
                password: '',
            }
        },
        beforeMount() {
            this.clearAuthenticationState()
        },
        computed: {
            ...mapGetters([
                'isLoggingIn'
            ])
        },
        methods: {
            ...mapActions([
                'adminLogin'
            ]),

            ...mapMutations([
                'clearAuthenticationState'
            ]),

            loginSubmit(e) {
                e.preventDefault()

                if (this.isFormValid())
                    this.adminLogin({ email: this.email, password: this.password })
            },

            isFormValid() {
                let isValid = true

                if (!this.email) {
                    this.$notify({
                        group: 'errors',
                        title: 'Greska u prijavi',
                        text: `Email ne moze da bude prazan!`
                    })
                    isValid = false
                }

                if (!this.password) {
                    this.$notify({
                        group: 'errors',
                        title: 'Greska u prijavi',
                        text: `Sifra ne moze da bude prazna!`
                    })
                    isValid = false
                }

                return isValid
            }
        }
    }
</script>

<style scoped>
    .background {
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        padding-top: 10%;
        background: #1A1A1A;
    }

    .login-form-wrapper {
        max-width: 450px;
        background: #FFF;
        margin-left: auto;
        margin-right: auto;
        padding: 45px;
        border-radius: 5px;
    }

    .login-form-wrapper input {
        margin: 0 4px 15px;
        padding: 15px;
    }
</style>